<template>
    <div v-if="isAuth" class="flex-column justify-center gap-0 py-0 xl:py-3 lg:py-3 md:py-2"
        :class="(screenSize=='xs' || screenSize=='sm') ? 'hidden' : 'flex'">
        <div class="flex flex-column">
            <LeftMenu :list="personal" />
        </div>
        <Divider v-if="personal"/>
        <div v-if="admin && admin.length" class="flex flex-column">
            <span class="w-full px-3 py-2 text-sm text-500">Админка</span>
            <LeftMenu :list="admin" />
        </div>
        <Divider v-if="admin && admin.length"/>
        <div class="flex flex-column">
            <LeftMenu :list="logout" />
        </div>
    </div>
    <Button label="Меню" @click='dialog = true' class="w-full border-noround surface-0 border-0" icon="pi pi-bars"
        :class="(screenSize=='xs' || screenSize=='sm') ? 'flex' : 'hidden'"/>

    <Dialog class="flex flex-column border-none max-w-30rem" modal
        v-model:visible="dialog"
        :position="screenSize=='xs' || screenSize=='sm' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: '900px' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs' || screenSize=='sm') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Меню</span>
            </div>
        </template>

        <div class="flex flex-column gap-0">
            <div class="flex flex-column">
                <LeftMenu :list="personal" @item-click="onMenuItemClick" />
            </div>
            <Divider v-if="personal"/>
            <div v-if="admin && admin.length" class="flex flex-column">
                <span class="w-full px-3 py-2 text-sm text-500">Админка</span>
                <LeftMenu :list="admin" @item-click="onMenuItemClick"/>
            </div>
            <Divider v-if="admin && admin.length"/>
            <div class="flex flex-column">
                <LeftMenu :list="logout" @item-click="onMenuItemClick"/>
            </div>
        </div>

        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Закрыть" icon="pi pi-times" @click="dialog = false" outlined class="flex w-full" autofocus severity="secondary" :disabled="loading"/>
            </div>
        </template>

    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import { useRouter } from 'vue-router'
import LeftMenu from '@/components/public/left_menu.vue'

export default {
    data() {
        return {
            dialog: false,
            personal: [],
            admin: [],
            logout: [
                {
                    label: 'Выйти',
                    icon: 'pi pi-sign-out',
                    route: '/logout/'
                },
            ]
        }
    },
    computed: {
        isAuth: function () { return this.$store.getters.isAuthenticated },
        accessCodes: function () { return this.$store.getters.StateUserAccessCodes },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    components: {
        LeftMenu
    },
    methods: {
        onMenuItemClick(item) {
            this.dialog = false
        },
        filterRoutes(menuTypes, accessCodes) {
            const routes = this.router.getRoutes()
            let results = []
            for(let r of routes){
                const metaCodes = r.meta.requireAccessCodes || []
                if(menuTypes.includes(r.meta.leftMenuType)){
                    if(
                        metaCodes.length === 0 ||
                        metaCodes.every(ac => accessCodes.includes(ac))
                    ){
                        results.push({
                            label:  r.meta.title_ru || r.meta.title || r.name,
                            icon:   r.meta.icon || null,
                            route:  r.path,
                            sort:   (r.meta && r.meta.sort) ? r.meta.sort : 0,
                            external: r.meta.external || false
                        })
                    }
                }
            }
            try { results.sort((a,b)=> a.sort - b.sort) } catch(e){}
            return results
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        this.router = useRouter()
    },
    async mounted() {
        this.personal = this.filterRoutes(['public','personal'], this.accessCodes)
        this.admin = this.filterRoutes(['admin'], this.accessCodes)
    },
}
</script>